import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  white-space: pre-line;
  gap: ${theme.typography.sizes.sm};
`
export const FieldWrapper = styled('div')`
  width: 100%;
`
export const Description = styled.p`
  margin: 0;
  max-width: 450px;
  line-height: ${theme.typography.lineHeight.md};
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
`
export const AlertBox = styled('div')`
  width: 450px;
`

export const WrapCheckBox = styled('div')`
  display: flex;
  flex-direction: column;

  & label > span:first-of-type {
    width: ${theme.spacing.xm};
  }
  & label > span:last-child {
    font-size: ${theme.typography.sizes.xs};
    font-weight: ${theme.typography.weight.xsm} !important;
    color: ${theme.colors.neutral.medium};
  }
`

export const AlertContent = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0;
  gap: 16px;
  padding-left: 16px;
`
